import React, { useState, useEffect, useCallback } from 'react';
import { fetchYoungProfRsvpAnalytics } from '../../api/client';
import YoungProfRsvpAnalytics from '../YoungProfRsvpAnalytics/YoungProfRsvpAnalytics';
import YoungProfRsvpList from '../YoungProfRsvpList/YoungProfRsvpList';

export default function YoungProfRsvpTab() {
  const [analytics, setAnalytics] = useState(null);

  const loadAnalytics = useCallback(async () => {
    try {
      const res = await fetchYoungProfRsvpAnalytics();
      setAnalytics(res.data);
    } catch (_e) {
      setAnalytics(null);
    }
  }, []);

  useEffect(() => {
    loadAnalytics();
  }, [loadAnalytics]);

  return (
    <div>
      <YoungProfRsvpAnalytics analytics={analytics} />
      <YoungProfRsvpList />
    </div>
  );
}
